import React, { useState, useRef } from 'react';

import { Button } from '@mui/material';
import Container from 'common/components/Container';
import Spinner from 'common/components/Spinner';
import DeliveryForm, { FormHandler } from './components/DeliveryForm';
import SetPageTitle from 'components/Portals/SetPageTitle';
import SetPageNavAction from 'components/Portals/SetPageNavAction';

import { Routes } from 'routing';
import { useTranslation } from 'services/localization/useTranslation';

const CreateDelivery = () => {
	const { t } = useTranslation();

	const [loading, setLoading] = useState<boolean>(false);
	const formRef = useRef<FormHandler>();

	return (
		<>
			<SetPageTitle
				title={t('delivery.newDeliveryOption', 'New delivery option')}
				priority={2}
				rightContent={
					<Button
						disabled={loading}
						onClick={() => formRef.current?.handleSubmit()}
						variant="contained"
						color="primary"
					>
						{loading ? (
							<Spinner padding={8} thickness={4} color="white" />
						) : (
							t('common:actions.create')
						)}
					</Button>
				}
			/>
			<SetPageNavAction
				backAction={{
					to: Routes.DELIVERY,
					title: t('delivery.delivery', 'Delivery'),
				}}
			/>
			<Container densePaddingTop>
				<DeliveryForm ref={formRef} setLoading={setLoading} />
			</Container>
		</>
	);
};

export default CreateDelivery;
